import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "sonner";

import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AnalysisProvider } from "@/context/AnalysisContext";
import { UIProvider } from "@/context/UIContext";

import { DashboardLayout } from "@/components/layout/DashboardLayout";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import AdLibrary from "@/pages/AdLibrary";
import Analytics from "@/pages/Analytics";
import AIInsights from "@/pages/AIInsights";
import Compare from "@/pages/Compare";
import Settings from "@/pages/Settings";
import AnalysisView from "@/pages/AnalysisView";
import ComingSoon from "@/pages/ComingSoon";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }
  if (user === null) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AnalysisProvider>
          <UIProvider>
            <BrowserRouter>
              <Toaster position="top-center" richColors closeButton />
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route
                  element={
                    <Protected>
                      <DashboardLayout />
                    </Protected>
                  }
                >
                  <Route path="/dashboard" element={<Overview />} />
                  <Route path="/library" element={<AdLibrary />} />
                  <Route path="/ad-library" element={<Navigate to="/library" replace />} />
                  <Route path="/analytics" element={<Analytics />} />
                  <Route path="/compare" element={<Compare />} />
                  <Route path="/ai-insights" element={<AIInsights />} />
                  <Route path="/competitors" element={<ComingSoon page="competitors" />} />
                  <Route path="/ideas" element={<ComingSoon page="ideas" />} />
                  <Route path="/team" element={<ComingSoon page="team" />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/analysis/:id" element={<AnalysisView />} />
                </Route>
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </BrowserRouter>
          </UIProvider>
        </AnalysisProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
